const DEVICE_REVOKE_TIMEOUT_MS = 3_000;
const SESSION_REVOKE_TIMEOUT_MS = 5_000;

async function withTimeout(
  operation: () => Promise<unknown>,
  timeoutMs: number,
): Promise<boolean> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  try {
    await Promise.race([
      Promise.resolve().then(operation),
      new Promise<never>((_, reject) => {
        timeoutId = setTimeout(
          () => reject(new Error("Logout request timed out")),
          timeoutMs,
        );
      }),
    ]);
    return true;
  } catch {
    return false;
  } finally {
    if (timeoutId !== undefined) clearTimeout(timeoutId);
  }
}

/**
 * Logout must not be held hostage by an optional notification cleanup call.
 * A timed-out device revoke is safe to abandon because session revocation is
 * the security boundary; the caller can reload if the session revoke also
 * cannot complete.
 */
export async function logoutWithRecovery({
  revokeRegisteredDevice,
  revokeSession,
}: {
  revokeRegisteredDevice: () => Promise<unknown>;
  revokeSession: () => Promise<unknown>;
}): Promise<boolean> {
  await withTimeout(revokeRegisteredDevice, DEVICE_REVOKE_TIMEOUT_MS);
  return withTimeout(revokeSession, SESSION_REVOKE_TIMEOUT_MS);
}
